import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

import { auth } from '@/firebase'
import { onMounted, onUnmounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import LeftNavigation from '@/components/LeftNavigation.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import LoginFormDialog from '@/components/LoginFormDialog.vue';
import { provide } from 'vue';
import router from './router';
import { Unsubscribe } from 'firebase/auth';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();

// テンプレートは共通なので、ここで定義
let unsubscribeTemplates: () => void | undefined;
let unsubscribePrivateTemplates: () => void | undefined;
let unsubscribePlugins: () => void | undefined;
let unsubscribePrivatePlugins: () => void | undefined;

let unsubscribeAuthStateChanged: Unsubscribe;
// ログインフォーム
let isLoginFormDialogOpen = ref(true);

// 認証ユーザーの状態監視
onMounted(() => {
  console.log('mounted');
  // 認証状態が変化した時にauthを反映する
  unsubscribeAuthStateChanged = auth.onAuthStateChanged(async (user) => {    
    if (user) {
      console.log("user is signed in");
      store.commit('firebase/signIn', user);
      // テンプレートの購読
      unsubscribeTemplates = await store.dispatch('subscribeTemplates', false);
      unsubscribePrivateTemplates = await store.dispatch('subscribeTemplates', true);
      unsubscribePlugins = await store.dispatch('subscribePlugins', false);
      unsubscribePrivatePlugins = await store.dispatch('subscribePlugins', true);

    } else {
      console.log("user is not signed in");
      store.commit('firebase/signOut');
      isLoginFormDialogOpen.value = true;
    }
  });
  // ログインフォームへ
  if (!store.state.firebase.user) {
    console.log('not logged in');
    isLoginFormDialogOpen.value = true;
    router.push('/');
  } else {
    isLoginFormDialogOpen.value = false;
  }
  
});

onUnmounted(() => {
  // Unsubscribe from Firebase Authentication state changes
  unsubscribeAuthStateChanged();
  unsubscribeTemplates && unsubscribeTemplates();
  unsubscribePrivateTemplates && unsubscribePrivateTemplates();
  unsubscribePlugins && unsubscribePlugins();
  unsubscribePrivatePlugins && unsubscribePrivatePlugins();
  store.commit('clearTemplates', false);
  store.commit('clearTemplates', true);
  store.commit('clearPlugins', false);
  store.commit('clearPlugins', true);
})

watch(() => store.state.firebase.user, (value) => {
  console.log('user', value);
  if (value) isLoginFormDialogOpen.value = false;
});

// 共通コンポーネント

// 確認ダイアログ
let isDialogOpen = ref(false);
let confirmed = ref(false);
let canceled = ref(false);
let titleRef = ref('');
let messageRef = ref('');
let typeRef = ref('confirm');

const onConfirm = () => {
  console.log('confirm');
  confirmed.value = true;
}
const onCancel = () => {
  console.log('cancel');
  canceled.value = true;
}
const showConfirmDialog = async (title: string, message: string, type = 'confirm') => {
  isDialogOpen.value = true;
  titleRef.value = title;
  messageRef.value = message;
  typeRef.value = type;

  // 300msごとに確認
  while (!confirmed.value && !canceled.value) {
    console.log('waiting...', isDialogOpen.value);
    await new Promise(resolve => setTimeout(resolve, 300));
  }
  isDialogOpen.value = false;
  if (confirmed.value) {
    confirmed.value = false;
    return true;
  } else {
    canceled.value = false;
    return false;
  }
}
provide('confirmDialog', showConfirmDialog);


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(LeftNavigation),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(ConfirmDialog, {
        isDialogOpen: _unref(isDialogOpen),
        title: _unref(titleRef),
        message: _unref(messageRef),
        type: _unref(typeRef),
        onConfirm: onConfirm,
        onCancel: onCancel
      }, null, 8, ["isDialogOpen", "title", "message", "type"]),
      (_unref(isLoginFormDialogOpen))
        ? (_openBlock(), _createBlock(LoginFormDialog, {
            key: 0,
            isDialogOpen: _unref(isLoginFormDialogOpen)
          }, null, 8, ["isDialogOpen"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})